<div class="">
  <div class="row">
    <div class="col-md-4">
      <div class="card social-widget widget-hover">
        <div class="card-body">   
          <div class="social-content">
            <div>
              <h5 class="mb-1">VENCIDAS</h5>
              <span class="f-light">Cantidad: {{cantidadVencidos}}</span>              
            </div>            
           <div>            
             
            </div>
            <div class="social-chart">
              <div>
                <apx-chart
                *ngIf="chartOptions"
                [series]="chartOptions.series"
                [chart]="chartOptions.chart"
                [xaxis]="chartOptions.xaxis"
                [title]="chartOptions.title"
                [plotOptions]="chartOptions.plotOptions"
                [colors]="chartOptions.colors"
              ></apx-chart>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-4">
      <div class="card social-widget widget-hover">
        <div class="card-body">   
          <div class="social-content">
            <div>
              <h5 class="mb-1">POR VENCER</h5>
              <span class="f-light">Cantidad: {{cantidadPorVencer}}</span>
            </div>
            <div class="social-chart">
              <div>
                <apx-chart
                *ngIf="chartOptions2"
                [series]="chartOptions2.series"
                [chart]="chartOptions2.chart"
                [xaxis]="chartOptions2.xaxis"
                [title]="chartOptions2.title"
                [plotOptions]="chartOptions2.plotOptions"
                [colors]="chartOptions2.colors"
              ></apx-chart>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-4">
      <div class="card social-widget widget-hover">
        <div class="card-body">   
          <div class="social-content">
            <div>
              <h5 class="mb-1">VIGENTES</h5>
              <span class="f-light">Cantidad: {{cantidaVigente}}</span>
            </div>
            <div class="social-chart">
              <div>
                <apx-chart
                *ngIf="chartOptions2"
                [series]="chartOptions3.series"
                [chart]="chartOptions3.chart"
                [xaxis]="chartOptions3.xaxis"
                [title]="chartOptions3.title"
                [plotOptions]="chartOptions3.plotOptions"
                [colors]="chartOptions3.colors"
              ></apx-chart>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
